import { render, staticRenderFns } from "./AccountParentEdit.vue?vue&type=template&id=6534bf14&scoped=true&"
import script from "./AccountParentEdit.vue?vue&type=script&lang=js&"
export * from "./AccountParentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534bf14",
  null
  
)

export default component.exports